import { useContext } from "react";

import QualifierContext from "../QualifierContext";
import { QualifierContextType } from "../types/QualifierContextType";

const useQualifierContext = (): QualifierContextType =>
	useContext(QualifierContext);

export default useQualifierContext;
